import React from "react";
import { connect } from "react-redux";

class DataSheetRow extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
        <div
          className="col-5"
          style={{ display: "flex", justifyContent: "right" }}
        >
          <p>{this.props.description}</p>
        </div>
        <div
          className="col-2"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div>
            <input
              className="form-control"
              type="text"
              autoComplete="off"
              id={this.props.inputId}
              placeholder={this.props.inputValue}
              disabled={this.props.inputType === "calc" ? true : false}
            ></input>
          </div>
        </div>
        <div
          className="col-5"
          style={{ display: "flex", justifyContent: "left" }}
        >
          <p>{this.props.comment}</p>
        </div>
      </div>
    );
  }
}

export default connect()(DataSheetRow);
